import CryptoJS from "crypto-js";

export const encrypt = (data) => {
  return new Promise((resolve, reject) => {
      try {
          const rawData = JSON.stringify(data.data);
          const key = CryptoJS.enc.Latin1.parse("Z3us3ncryPtEd.K3Y.Z3us3ncryPtEd+");
          const iv = CryptoJS.lib.WordArray.random(128 / 8);
          const cipherData = CryptoJS.AES.encrypt(rawData, key, { iv: iv });
          const cipher = cipherData.iv.concat(cipherData.ciphertext);
          resolve({ data: CryptoJS.enc.Base64.stringify(cipher) });
      }
      catch (e) {
          reject("Missing values to encrypt");
      }
  });
};

export const decrypt = (data) => {
  return new Promise((resolve, reject) => {
      try {
          const rawData = CryptoJS.enc.Base64.parse(data.data);
          const key = CryptoJS.enc.Latin1.parse("Z3us3ncryPtEd.K3Y.Z3us3ncryPtEd+");
          const iv = CryptoJS.enc.Latin1.parse(rawData.toString().substring(0, 16));
          const plaintextData = CryptoJS.AES.decrypt({ ciphertext: rawData }, key, { iv: iv });
          let plaintext = plaintextData.toString(CryptoJS.enc.Latin1);
          plaintext = plaintext.replace(plaintext.substring(0, 16), '');
          resolve({ data: JSON.parse(decodeURIComponent(escape(plaintext))) });
      }
      catch (e) {
          reject("String cannot be decrypted");
      }
  })
}